module.exports = __webpack_public_path__ + "img/spinner_black.e45bf660.svg";